export enum apiUrlAdvertising {
    ADVERTISEMENT = '/v1/advertisement/',
    TRANSACTION_UPDATE = '/v1/transactions_update/',
}
